import Vue from "vue";

Vue.component("tbt-regular-referenced-notifications", {
	props: ["documentSymbol", "searchUrl"],
	data() {
		return {
			showReferencedNotificationDetails: false,
			referencedNotificationViewModel: {},
			referencedNotifications: [],
			loading: true
		};
	},
	computed: {
		referencedNotificationsLabel() {
			return window.labels.referencedNotifications;
		},
		closeLabel() {
			return window.labels.closeText;
		},
		loadingText() {
			return window.labels.loading + "..";
		},
		dolLinkUrl() {
			return '/' + window.currentLanguage + '/DOL/GetDocument';
		},
	},
	methods: {
		showReferencedNotificationDataDetails: function (documentSymbol) {
			this.$services.notifications.getViewNotification({ documentSymbol: documentSymbol })
				.then((response) => {
					let pdfUrl = null;
					if (response.dolLink) {
						const docs = response.dolLink.replace(/\\/g, "/");
						const symbol = docs.split('.');
						pdfUrl = `${window.location.origin}/viewer/web/viewer.html?file=` + escape(`${this.dolLinkUrl}?dolLink=${symbol[0]}&notificationId=${response.id}`);
					}
					this.referencedNotificationViewModel = {
						id: response.id,
						dolLink: pdfUrl,
						symbol: response.documentSymbol,
						domain: response.domain,
						countryId: response.countryId
					};

					this.showReferencedNotificationDetails = true;
				});
		},
	},
	mounted() {
		this.loading = true;
		this.$services.notifications.getReferencedNotifications({
			documentSymbol: this.documentSymbol
		})
			.then((data) => {
				this.loading = false;
				this.referencedNotifications = data;
			});
	},
	template: `
      <div>
      	<div v-if="loading">
	        <loading :loading-text="loadingText"></loading>
      	</div>
      	<div v-else-if="referencedNotifications && referencedNotifications.length > 0" class="column is-full pt-0 pb-1 pl-0">
		  <strong>{{ referencedNotificationsLabel }}</strong>:
		  <a v-for="(item, index) in referencedNotifications" v-bind:key="item" class="symbol-link" onclick="return false;" @click="showReferencedNotificationDataDetails(item)">{{ item }}<span v-if="referencedNotifications.length > 1 && referencedNotifications.length -1 !== index">, </span></a>
		</div>
		<b-modal v-model="showReferencedNotificationDetails" #default="props">
			<div class="modal-card" style="width: 100% !important; height: 100% !important">
				<header class="modal-card-head">
					<p class="modal-card-title truncate-overflow-1" :title="referencedNotificationViewModel.symbol">{{ referencedNotificationViewModel.symbol }}</p>
				</header>
				<section class="modal-card-body">
					<div class="columns" style="height: 100%; display: flex; flex-direction: column;">
						<div style="position: relative">
							<div class="column is-full pt-0 pb-1 pl-0">&nbsp;</div>
							<notification-download-document :notification-id="referencedNotificationViewModel.id"></notification-download-document>
						</div>
						<div class="column is-full m-0 p-0" style="flex: 1;" v-if="referencedNotificationViewModel.dolLink">
							<iframe :src="referencedNotificationViewModel.dolLink" style="height: 100%; width: 100%"></iframe>
						</div>
					</div>
				</section>
				<footer class="modal-card-foot buttons is-right">
					<b-button :label="closeLabel" @click="props.close"></b-button>
				</footer>
			</div>
		</b-modal>
	  </div>
	`,
});